import { TariffViewModel } from '@common/model/billing/tariff/view';

export const getTariffPriceWithDiscount = (tariff: TariffViewModel) => {
  return tariff.price - tariff.discount;
};
